/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component } from '@angular/core';
import { FooterService } from '../../shared/services/footer.service';
import { Status } from '../../shared/model/status';
import { ALERTTYPE } from '../../config/constants';
import { Application } from '../model/application';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'footer-comp',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  public footerMsg: Application = new Application();
  public status: Status = new Status();
  public showAlert = '';
  public alertLabel = 'Application Updated Successfully.';
  public ALERTTYPE = ALERTTYPE;
  public dateObj1: Date = new Date();

  constructor(private footerService: FooterService, private commonService: CommonService) {
    this.getApplicationDetails();
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  private getDateObjFromUTC(milliseconds: any) {
    const date = new Date(milliseconds);
    this.dateObj1 = date;
  }

  public getApplicationDetails() {
    this.footerService
      .getApplicationDetails()
      .then(this.getApplicationDetailSuccessHandler.bind(this), this.getApplicationDetailFailureHandler.bind(this));
  }

  public getApplicationDetailSuccessHandler(data: any) {
    this.footerMsg = data;
    this.getDateObjFromUTC(this.footerMsg.releaseDate);
  }

  public getApplicationDetailFailureHandler(error: any) {
    this.status = error;
    if (this.status) {
      if (this.status.message) {
        this.showAlertFun(ALERTTYPE.ERROR, this.status.message);
      } else {
        this.showAlertFun(ALERTTYPE.ERROR, this.status.errors.message);
      }
    }
  }

  public showAlertFun(type: string, msg: string) {
    this.showAlert = type;
    this.alertLabel = msg;
  }
}
